import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import "./i18n/config";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Expertise from "./components/Expertise";
import ExecutiveSearch from "./components/ExecutiveSearch";
import Services from "./components/Services";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Header />
        <Hero />
        <About />
        <Expertise />
        <ExecutiveSearch />
        <Services />
        <Testimonials />
        <Contact />
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
